import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function MinistriesPage() {
  return (
    <div className="main-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <EditableText id="ministries.title" defaultContent="教会事工" defaultStyle={PAGE_TITLE_STYLE} />
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="ministries.intro"
          defaultContent={"我们的主来到这个世界上不是为了受人服事，而是为了事奉人。我们是他的门徒，因此也应当效法他的榜样（马太福音20:28）。\n如果你愿意奉献你的时间与才干，与弟兄姐妹们一同在基督里事奉神的话，请参考下面所列的服事岗位。"}
          defaultStyle={BODY_STYLE}
        />
      </section>
      <section style={{ display: "flex", flexWrap: "wrap", gap: 32, background: "#e6f7ff", borderRadius: 8, padding: 24, margin: "32px 0" }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <EditableText id="ministries.student-title" as="h3" defaultContent="学生团契服事" />
          <EditableText
            id="ministries.student-list"
            as="div"
            defaultContent={"1. 圣经老师\n2. 多媒体团队\n3. 福音小组"}
          />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <EditableText id="ministries.adult-title" as="h3" defaultContent="成人事工服事" />
          <EditableText
            id="ministries.adult-list"
            as="div"
            defaultContent={"1. 儿顾团队\n2. 主日学老师\n3. 圣经老师\n4. 传福音小组\n5. 后勤团队\n6. 设备维护\n7. 饭食准备"}
          />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <EditableText id="ministries.sunday-title" as="h3" defaultContent="主日崇拜" />
          <EditableText
            id="ministries.sunday-list"
            as="div"
            defaultContent={"1. 接待\n2. 敬拜团队\n3. 多媒体团队\n4. 儿顾团队\n5. 主日学老师"}
          />
        </div>
      </section>
      <PageCopyright pageId="ministries" />
    </div>
  );
}

export default MinistriesPage;
